import { Fragment } from 'react'

import { getQaSelector } from '../../../utils/common'
import { Divider } from '../../Divider'
import { Headline2 } from '../../Headline2'

import { QA_NAME_ENTITY_TAB_ATTRIBUTES } from './EntityTabAttributes.constants'
import {
  getEntityTabAttributeNonEmptyEntries,
  isEntityTabAttributeGroupValue,
} from './EntityTabAttributes.utils'
import { EntityTabAttributesEntry } from './EntityTabAttributesEntry'
import { EntityTabAttributesGroup } from './EntityTabAttributesGroup'

import * as styles from './EntityTabAttributes.module.css'

function EntityTabAttributes({
  attributes,
  qaName = QA_NAME_ENTITY_TAB_ATTRIBUTES,
  title,
}) {
  const entries = getEntityTabAttributeNonEmptyEntries(attributes)

  return entries.length > 0 ? (
    <div {...getQaSelector({ value: qaName })} className={styles.container}>
      {title ? (
        <>
          <div className={styles.header}>
            <Headline2>{title}</Headline2>
          </div>
          <Divider className={styles.headerDivider} />
        </>
      ) : null}

      {entries.map(([label, value], index) => (
        <Fragment key={label}>
          {index > 0 ? <Divider className={styles.divider} /> : null}
          <div className={styles.entry}>
            {isEntityTabAttributeGroupValue(value) ? (
              <EntityTabAttributesGroup label={label} value={value} />
            ) : (
              <EntityTabAttributesEntry label={label} value={value} />
            )}
          </div>
        </Fragment>
      ))}
    </div>
  ) : null
}

export default EntityTabAttributes
